import React, { useState } from 'react';
import { Alert, Input, Modal, Typography } from 'antd';
import { O365OnboardingListItem } from '../../../../services/o365/o365Onboarding/o365Onboarding.model';

const { Text } = Typography;

interface ResetTenantModalProps {
  row: O365OnboardingListItem;
  // Resolves true when the reset succeeded (the parent then unmounts this modal).
  onConfirm: () => Promise<boolean>;
  onClose: () => void;
}

const ResetTenantModal: React.FC<ResetTenantModalProps> = ({ row, onConfirm, onClose }) => {
  const [typed, setTyped] = useState('');
  const [saving, setSaving] = useState(false);
  // bu_name is nullable in the list; fall back to a fixed word so the guard still works.
  const confirmWord = row.bu_name || 'RESET';

  const handleOk = async () => {
    setSaving(true);
    if (!(await onConfirm())) setSaving(false);
  };

  return (
    <Modal
      wrapClassName="custom-modal"
      title="Reset Microsoft 365 tenant?"
      centered
      visible
      onCancel={onClose}
      onOk={handleOk}
      okText="Reset tenant"
      okButtonProps={{ danger: true, disabled: typed.trim() !== confirmWord, loading: saving }}
      cancelText="Cancel"
      width={560}
    >
      <Alert
        type="error"
        showIcon
        message={
          <>
            This <strong>unlinks the Microsoft 365 tenant</strong> from{' '}
            <em>
              {row.company_name ?? '–'} / {row.bu_name ?? '–'}
            </em>
            .
          </>
        }
        style={{ marginBottom: 12 }}
      />
      <ul style={{ paddingLeft: 20 }}>
        <li>It clears the linked tenant and marks the connection inactive.</li>
        <li>The client link can then be consented by a different Microsoft 365 tenant.</li>
        <li>Existing collected data isn&apos;t deleted.</li>
        <li>
          A collection schedule for this BU keeps running and fails until the BU is reconnected.
          Stop it on the Scheduler screen if needed.
        </li>
      </ul>
      <div className="form-group m-0">
        Type <Text code>{confirmWord}</Text> to confirm
        <Input
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          aria-label="Confirm reset"
          autoComplete="off"
        />
      </div>
    </Modal>
  );
};

export default ResetTenantModal;
